<div class="modal-backdrop" #backDropRef
     (touchstart)="onTouchStart($event)"
     (touchmove)="onTouchMove($event)"
     (touchend)="onTouchEnd($event)">
  <div class="modal" [class]="cssClass"
       [ngStyle]="{ transform: 'translateY(' + currentTranslateY + 'px)' }"
       [class.animate-back]="animateBack"
       [class.slide-down]="slideDown"
       (transitionend)="onTransitionEnd()">
    <div class="modal-header"  [class]="headerClass">
      @if (titleTemplate) {
        <div class="modal-title">
          @if (isOpen) {
            <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
          }
        </div>
      }
      @if (closable) {
        <button type="button" class="modal-close" (click)="close()">
          <i class="icon-x-close"></i>
        </button>
      }
    </div>

    <div class="modal-body" [class]="bodyClass">
      @if (isOpen) {
        <ng-container [ngTemplateOutlet]="bodyTemplate"></ng-container>
      }
    </div>
  </div>
</div>
